// extracted by mini-css-extract-plugin
export var accordion = "_hw-0";
export var chevron = "_hw-3";
export var closed = "_hw-2";
export var content = "_hw-4";
export var open = "_hw-1";
export var rotate = "_hw-5";